import React, { useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "./authContext";
import { getCheckProviderURL, postQueryData, withCredentials } from "../services";
import { useNavigate } from "react-router-dom";

const appContextObject = React.createContext<any>({
    userData: null,
    providerId: null,
    fetchProvider: () => { }
});

const useAppContext = () => useContext(appContextObject);

const AppProvider = ({ children }: any) => {
    const navigate = useNavigate()
    const [userData, setUserData] = useState();

    const { isAuthenticated } = useAuth();
    const providerId = localStorage.getItem('providerID') || ""

    const handleRoute = (itemData: any) => {
        if (itemData?.appOnBoardings) {
            const nextStep = itemData.appOnBoardings.find((step: any) => !step.isDone);
            const routeMap: any = {
                TermsCondition: "/terms-of-use",
                PersonalInformation: "/professional-information",
                PracticeInformation: "/practice-information"
            };

            if (nextStep) {
                navigate(routeMap[nextStep.type]);
            }
            else if (!itemData?.isNpiVerified) {
                navigate("/practice-information");
            }
            console.log("after steps");
        }
    }

    const fetchProvider = () => {
        postQueryData(getCheckProviderURL, withCredentials()).then((res) => {
            if (res?.data) {
                setUserData(res?.data?.data)
                localStorage.setItem('providerID', res?.data?.data?.providerId)
                handleRoute(res?.data?.data)
            }
        })
            .catch((error) => console.log("provider api error:-", error))
    }

    useEffect(() => {
        if (isAuthenticated) {
            fetchProvider()
        }
    }, [isAuthenticated])

    const value = useMemo(() => {
        return {
            userData,
            providerId,
            fetchProvider
        }
    }, [providerId, userData, fetchProvider])

    return (
        <appContextObject.Provider
            value={value}>
            {children}
        </appContextObject.Provider>
    );
};

export { useAppContext, AppProvider };